<div mat-dialog-title>
  <div class="scale-down">
    <app-lower-third [broadcast]="broadcast" [controlAction]="'on'"></app-lower-third>
  </div>
</div>
<div mat-dialog-content>
  <mat-tab-group>
    <mat-tab [label]="broadcast.config.awayConfig.fullName">
      <div class="button-container">
        <mat-grid-list cols="4" rowHeight="40">
          <mat-grid-tile *ngFor="let player of awayRoster">
            <button class="select-button" mat-stroked-button
                    [class.selected]="broadcast.lowerThird.guid === player.guid"
                    (click)="selectPerson(player)">
              {{utilService.getNumber(player, broadcast)}} {{player.name}}
            </button>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </mat-tab>
    <mat-tab [label]="broadcast.config.homeConfig.fullName">
      <div class="button-container">
        <mat-grid-list cols="4" rowHeight="40">
          <mat-grid-tile *ngFor="let player of homeRoster">
            <button class="select-button" mat-stroked-button
                    [class.selected]="broadcast.lowerThird.guid === player.guid"
                    (click)="selectPerson(player)">
              {{utilService.getNumber(player, broadcast)}} {{player.name}}
            </button>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </mat-tab>
    <mat-tab label="Other" *ngIf="otherRoster?.length">
      <div class="button-container">
        <mat-grid-list cols="4" rowHeight="40">
          <mat-grid-tile *ngFor="let player of otherRoster">
            <button class="select-button" mat-stroked-button
                    [class.selected]="player.guid ? broadcast.lowerThird.guid === player.guid : broadcast.lowerThird === player"
                    (click)="selectPerson(player)">
              {{player.name}}{{player.info ? ' – ' + player.info : ''}}
            </button>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </mat-tab>
    <mat-tab label="Custom">
      <form [formGroup]="custom">
        <div>
          <div class="radio-label">
            <label>Color and logo</label>
          </div>
          <mat-radio-group formControlName="teamGuid">
            <mat-radio-button [value]="broadcast.config.awayConfig.id">
              Away
            </mat-radio-button>
            <mat-radio-button [value]="broadcast.config.homeConfig.id">
              Home
            </mat-radio-button>
            <mat-radio-button [value]="null">
              Neutral
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div>
          <mat-form-field>
            <mat-label>Main title</mat-label>
            <input matInput formControlName="name">
            <mat-icon matSuffix inline (click)="custom.controls.name.reset()" *ngIf="broadcast.lowerThird.name">clear</mat-icon>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <mat-label>Info line</mat-label>
            <input matInput formControlName="info">
            <mat-icon matSuffix inline (click)="custom.controls.info.reset()" *ngIf="broadcast.lowerThird.info">clear</mat-icon>
          </mat-form-field>
        </div>
      </form>
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions>
  <button mat-flat-button [mat-dialog-close]="false">
    Close
  </button>
  <button mat-flat-button color="primary" (click)="update()" cdkFocusInitial>
    <mat-icon>done</mat-icon>
    Update
  </button>
</div>
